var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"hidden-sm-and-down",attrs:{"icon":""},on:{"click":_vm.toggleFullScreen}},[_c('v-icon',[_vm._v("fullscreen")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }